import axios from 'axios'
import storage from 'store'
const urlStr = process.env.NODE_ENV === 'production' ? '/marjan/portal' : process.env.VUE_APP_BASEURL
const request = axios.create({
  baseURL: urlStr,
  timeout: 6000,
})
//////////////////////////////////////////////////////////
import { JSEncrypt } from 'jsencrypt'
const encryptedData = function (data) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCodu6J3woOZeIv+viH2CYbCRfVwuRG+bLZP3welc3s3f842ut000F4BTcVfJpwn0xYnwpqQhjQI3LmWupgnZTs8YbbosqYLQNEtF7STBaQm8UJxBi0YvLvsbkuvCGnq83z1usxnN2jl0J3FkC9oVkxhhZ7XDrF6rOtWxvW5QMH3wIDAQAB')
  return encryptor.encrypt(data)
}
/////////////////////////////////////////////////////////
request.interceptors.request.use(
  (config) => {
    const token = storage.get('Access-Token');
    if (token) {
      config.headers['Authorization'] = token
      const urlStr = config.url.includes('?')
      ?
      config.url.substring(urlStr.length, config.url.indexOf('?'))
      :
      config.url.substring(urlStr.length);
      const code = encryptedData(token.substr(7, 20) + urlStr);
      config.headers['_verifycode'] = code
    }
    if(config.url.includes('download')){
      config.responseType = 'blob'
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
request.interceptors.response.use(
  (response) => {
    if (response.status == 401) {
      return location.replace(
        `${location.origin}/user/sso/login?from=${location.href}`
      )
    } else if(response.config.responseType == 'blob') {
      // let filename = response.headers["content-disposition"];
      const blob = new Blob([response.data]);
      // var downloadElement = document.createElement("a");
      var href = window.URL.createObjectURL(blob);
      return href;
      // if(filename.includes('pdf') || filename.includes('png') || filename.includes('jpg') || filename.includes('jpeg')){
      //   return href;
      // }else{
      //   downloadElement.href = href;
      //   let fname = filename.split("filename=")[1];
      //   downloadElement.download = decodeURIComponent(
      //     fname.replace(/\\"/g, "")
      //   );
      //   document.body.appendChild(downloadElement);
      //   downloadElement.click();
      //   document.body.removeChild(downloadElement);
      //   window.URL.revokeObjectURL(href);
      // }
    }else{
      return response.data
    }
  },
  (error) => {
    if(error.response.status == 401){
      return location.replace(
        `${location.origin}/user/sso/login?from=${location.href}`
      )
    }
    return Promise.reject(error)
  }
)
export default request